/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
function alert(options, context) {
    var _a;
    var api = 'dd.device.notification.alert';
    var formatInput = function (input) {
        var title = input.title, content = input.content, buttonText = input.buttonText;
        return {
            title: title,
            message: content,
            buttonName: buttonText,
        };
    };
    (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options, { formatInput: formatInput });
}

export { alert as default };
